import _get from 'lodash/get';

/**
 * Sanitize Payload before sending info to server
 * @param  {import('../stubs').FormSchemaType} data Form Data
 * @return {Object} Modified API payload in correct form
 */
export function sanitizePayload(data) {
  const productTypes = _get(data, 'productTypes', []);
  const productCategories = _get(data, 'productCategories', []);
  const collections = _get(data, 'collections', []);
  const excludedTags = _get(data, 'excludedTags', []);

  const payload = {
    min_price: +_get(data, 'minPrice', ''),
    show_digital_products: _get(data, 'showDigitalProducts', false),
    show_sale_items: _get(data, 'showSaleItems', false)
  };

  payload.product_types = productTypes.map(productType => ({
    title: _get(productType, 'label', ''),
    visible: true
  }));

  payload.collections = collections.map(collection => ({
    id: _get(collection, 'value', ''),
    title: _get(collection, 'label', ''),
    visible: true
  }));

  payload.product_categories = productCategories.map(category => ({
    id: _get(category, 'value', ''),
    visible: true
  }));

  payload.excluded_tags = excludedTags.map(tag => _get(tag, 'value', ''));

  return payload;
}
